import { foodImage, logo } from "@/assets";

const Template2 = ({ template, previewData }) => {
  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const backgroundImage = template?.image_url || foodImage;
  const logoImage = template?.logo_url || logo;
  const templateTitle = previewData?.title || (isStrictPreview ? "N/A" : "GIFT CARD");
  const customerName = previewData?.customerName || (isStrictPreview ? "Not provided" : "Md Rasel Mahmud");
  const cardCode = previewData?.code || (isStrictPreview ? "N/A" : "#32154232");
  const hasReward = previewData?.reward !== null && previewData?.reward !== undefined && previewData?.reward !== "";
  const reward = hasReward ? previewData?.reward : isStrictPreview ? "N/A" : 100;
  const rewardType = previewData?.rewardType || (isStrictPreview ? "" : "fixed");
  const quote = previewData?.message
    ? `\"${previewData.message}\"`
    : isStrictPreview
      ? "Not provided"
      : "\"Happy Anniversary\"";
  const paymentText = previewData?.paymentMethods?.length
    ? previewData.paymentMethods.map(m => m.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())).join(", ")
    : isStrictPreview
      ? "Not provided"
      : "Cash Only";
  const orderTypeText = previewData?.orderTypes?.length
    ? `For ${previewData.orderTypes.map(t => t.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())).join(" / ")} only`
    : isStrictPreview
      ? "Not provided"
      : "For dine in only ( not for Takeaway or Delivery )";
  const isConjunction =
    previewData?.isConjunction !== null && previewData?.isConjunction !== undefined
      ? Boolean(previewData?.isConjunction)
      : previewData?.is_conjunction !== null && previewData?.is_conjunction !== undefined
        ? Boolean(previewData?.is_conjunction)
        : !isStrictPreview;
  const conjunctionText = isConjunction ? "Not conjunction with any other offer" : null;
  const expiryText = previewData?.expiryDate || (isStrictPreview ? "N/A" : "12/05/2026");

  return (
    <div className="flex items-center justify-center p-4">
      <div
        data-export-capture="gift-card-template"
        className="relative w-full max-w-2xl h-[300px] shadow-2xl overflow-hidden rounded-sm flex "
      >
        
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        ></div>

        <div className="relative ml-4  z-10 w-[65%] mb-4 bg-[#b35307] text-white px-8 py-4 flex flex-col justify-between">
          
          <div>
            <div className="flex justify-between items-start">
              <div>
                <img src={logoImage} alt="Logo" className="w-20 mb-2" />
                <h1 className="text-2xl font-serif italic font-medium tracking-wide">
                  {templateTitle}
                </h1>
              </div>

              <div className="flex items-start">
                <span className="text-xs font-bold mt-1 mr-0.5">{rewardType === "percentage" || rewardType === "%" ? "" : "£"}</span>
                <span className="text-3xl font-bold leading-none">
                  {reward}
                  {rewardType === "percentage" || rewardType === "%" ? "%" : ""}
                </span>
              </div>
            </div>

            <div className="mt-3">
              <p className="text-xl font-medium">{customerName}</p>
              <p className="text-sm opacity-90 mt-1">Code {cardCode}</p>
            </div>

            {quote && quote !== "Not provided" && quote !== "No provide" && quote !== "\"Not provided\"" && quote !== "\"No provide\"" && (
              <p className="italic text-lg mt-2 font-light">{quote}</p>
            )}
          </div>

          {((paymentText && paymentText !== "Not provided" && paymentText !== "No provide") ||
            (orderTypeText && orderTypeText !== "Not provided" && orderTypeText !== "No provide") ||
            (conjunctionText && conjunctionText !== "Not provided" && conjunctionText !== "No provide") ||
            (expiryText && expiryText !== "N/A" && expiryText !== "Not provided" && expiryText !== "No provide")) && (
            <div className="text-[10px] opacity-90 tracking-wide">
              <p className="mb-1">-Terms & Conditions-</p>
              {paymentText && paymentText !== "Not provided" && paymentText !== "No provide" && <p>{paymentText}</p>}
              {orderTypeText && orderTypeText !== "Not provided" && orderTypeText !== "No provide" && <p>{orderTypeText}</p>}
              {conjunctionText && conjunctionText !== "Not provided" && conjunctionText !== "No provide" && <p>{conjunctionText}</p>}
              {expiryText && expiryText !== "N/A" && expiryText !== "Not provided" && expiryText !== "No provide" && <p>Exp. Date : {expiryText}</p>}
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default Template2;